

export const HOLD_DURATION = 1*24*60*60*1000;